import React from 'react';

import './Spinner.css';

const spinner = ({ small = false }) => (
    <div className={small ? "Loader sm" : "Loader"}>Loading...</div>
);

export default spinner;
